function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 0C1.34375 0 0 1.34375 0 3V9C0 10.6562 1.34375 12 3 12H5.625C5.8125 12 6 11.8438 6 11.625V10.875C6 10.6875 5.8125 10.5 5.625 10.5H3C2.15625 10.5 1.5 9.84375 1.5 9V3C1.5 2.1875 2.15625 1.5 3 1.5H5.625C5.8125 1.5 6 1.34375 6 1.125V0.375C6 0.1875 5.8125 0 5.625 0H3ZM10.2188 0.625L9.59375 1.25C9.4375 1.375 9.4375 1.625 9.59375 1.78125L13.125 5.1875H5.375C5.15625 5.1875 5 5.375 5 5.5625V6.4375C5 6.65625 5.15625 6.8125 5.375 6.8125H13.125L9.59375 10.25C9.4375 10.4062 9.4375 10.6562 9.59375 10.7812L10.2188 11.4062C10.3438 11.5625 10.5938 11.5625 10.75 11.4062L15.875 6.28125C16.0312 6.125 16.0312 5.90625 15.875 5.75L10.75 0.625C10.5938 0.46875 10.3438 0.46875 10.2188 0.625Z",
  fill: "currentColor"
});

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.13d57dd5.svg";
export { ForwardRef as ReactComponent };